import Vue from 'vue'
import Router from 'vue-router'
import VueWechatTitle from 'vue-wechat-title'
import Meta from 'vue-meta-info'
import { hasLogin } from 'common/js/store'
import { homeApp } from 'config'
const Index = () => import('components/index/index')
const Detail = () => import('components/detailPage/detail')
const Forget = () => import('components/forget/forget')
const ShopCart = () => import('components/shopCart/cart')
const Search = () => import('components/search/search')
const Order = () => import('components/createOrder/order')
const Report = () => import('components/report/report')
const Questions = () => import('components/questions/questions')
const Help = () => import('components/help/help')
const NLogin = () => import('components/NLogin/NLogin')
const Contact = () => import('components/contact/contact')
const NContainer = () => import('base/NContainer/NContainer')
const NHome = () => import('components/NHome/NHome')
const NewCase = () => import('components/NewCase/NewCase')
const NewCaseDetail = () => import('components/NewCaseDetail/NewCaseDetail')
const NAboutUs = () => import('components/NAboutUs/NAboutUs')
const NewRetail = () => import('components/NewRetail/NewRetail')
const Intelligence = () => import('components/intelligence/intelligence')
const NLoginTemp = () => import('components/NLoginTemp/NLogin')
Vue.use(Router)
Vue.use(VueWechatTitle)
Vue.use(Meta)

const router = new Router({
  routes: [
    {
      path: '/',
      component: NContainer,
      children: [
        {
          path: '/',
          name: 'nhome',
          component: NHome,
          meta: {
            title: '首页',
            login: false
          }
        }, {
          path: '/nhome',
          name: 'nhome',
          component: NHome,
          meta: {
            title: '首页',
            login: false
          }
        }, {
          path: '/newcase',
          component: NewCase,
          name: 'newcase',
          meta: {
            title: '新闻列表',
            login: false
          }
        }, {
          path: '/newcasedetail/:type',
          component: NewCaseDetail,
          name: 'newcasedetail',
          meta: {
            title: '新闻详情',
            login: false
          }
        }, {
          path: '/nAboutUs',
          name: 'nAboutUs',
          component: NAboutUs,
          meta: {
            title: '关于我们',
            login: false
          }
        },
        {
          path: '/newRetail',
          name: 'newRetail',
          component: NewRetail,
          meta: {
            title: '新零售4s店',
            login: false
          }
        },
        {
          path: '/intelligence',
          name: 'intelligence',
          component: Intelligence,
          meta: {
            login: false,
            title: '4S店智能管家'
          }
        }
      ]
    },
    {
      path: '/nlogin',
      name: 'nlogin',
      component: NLogin,
      meta: {
        login: false,
        title: '登录页'
      }
    },
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      meta: {
        login: false,
        title: '获客无忧平台'
      }
    }, {
      path: '/detail',
      name: 'Detail',
      component: Detail,
      meta: {
        login: false,
        title: '商品详情'
      }
    }, {
      path: '/forget',
      name: 'Forget',
      component: Forget,
      meta: {
        login: false,
        title: '忘记密码'
      }
    }, {
      path: '/cart',
      name: 'cart',
      component: ShopCart,
      meta: {
        login: true,
        title: '购物车'
      }
    }, {
      path: '/search',
      name: 'search',
      component: Search,
      meta: {
        login: false,
        title: '搜索页'
      }
    }, {
      path: '/order',
      name: 'order',
      component: Order,
      meta: {
        login: true,
        title: '提交订单'
      }
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      meta: {
        login: false,
        title: '联系我们'
      }
    },
    {
      path: '/report',
      name: 'report',
      component: Report,
      meta: {
        login: false,
        title: '媒体报道'
      }
    },
    {
      path: '/questions',
      name: 'questions',
      component: Questions,
      meta: {
        login: false,
        title: '常见问题'
      }
    },
    {
      path: '/help',
      name: 'help',
      component: Help,
      meta: {
        login: false,
        title: '使用帮助'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: NLoginTemp,
      meta: {
        login: false,
        title: '登录页'
      }
    }
  ]
})

router.beforeEach((to, form, next) => {
  console.log(hasLogin())
  if (to.meta.login === false) {
    next()
    return
  }
  if (hasLogin()) {
    next()
    return
  }
  window.top.location.replace(`${homeApp.NLoginUrl}`)// 嵌套iframe，统一登录页
  next()
})

router.afterEach((to, form, next) => {
  window.scrollTo(0, 0) // 跳转页面后回到顶部
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js